//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataLogModal from "./modules/DataLogModal";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JEllipsis from "@/components/jeecg/JEllipsis";
export default {
  name: 'DataLogList',
  mixins: [JeecgListMixin],
  components: {
    JEllipsis: JEllipsis,
    DataLogModal: DataLogModal
  },
  data: function data() {
    return {
      description: '数据日志管理页面',
      //表头
      columns: [{
        title: '表名',
        align: 'center',
        dataIndex: 'dataTable'
      }, {
        title: '数据ID',
        align: 'center',
        dataIndex: 'dataId'
      }, {
        title: '版本号',
        align: 'center',
        dataIndex: 'dataVersion'
      }, {
        title: '数据内容',
        align: 'center',
        dataIndex: 'dataContent',
        width: "120px",
        scopedSlots: {
          customRender: 'dataContent'
        }
      }, {
        title: '创建人',
        align: 'center',
        dataIndex: 'createBy'
      }],
      url: {
        list: "/sys/dataLog/list"
      }
    };
  },
  methods: {
    handleCompare: function handleCompare() {
      if (!this.selectionRows || this.selectionRows.length != 2) {
        this.openNotifIcon('请选择两条数据');
        return false;
      } else if (this.selectionRows[0].dataId != this.selectionRows[1].dataId) {
        this.openNotifIcon('请选择相同的数据库表和数据ID进行比较');
        return false;
      } else {
        this.$refs.modalForm.addModal(this.selectionRows);
        this.$refs.modalForm.title = "数据比较";
      }
    },
    openNotifIcon: function openNotifIcon(msg) {
      this.$notification['warning']({
        message: '提示信息',
        description: msg
      });
    }
  }
};